import React from "react";
import { CompanyNewsTileType } from "@irati/types";
import { StyledContentSvgCard, StyledContentWrapper, StyledImageTile } from "./styled";
import { StyledFlex, StyledDiv, StyledWrapper } from "../Template/styled";
import Message from "./Message";
import Icon from "../Template/Icon";
import TemplateTitle from "../Template/Title";
import TemplateFindOutMore from "../Template/FindOutMore";
var TemplateTile = function (_a) {
    var companyNewsTile = _a.companyNewsTile;
    if (companyNewsTile.config.type !== CompanyNewsTileType.Template) {
        return null;
    }
    var isMidSizedContent = companyNewsTile.config.columnWidth < 4;
    var _b = companyNewsTile.config, backgroundColor = _b.backgroundColor, message = _b.message, templateIcon = _b.templateIcon, templateText = _b.templateText;
    return (React.createElement(StyledImageTile, null,
        React.createElement(StyledContentWrapper, null,
            React.createElement(StyledWrapper, null,
                React.createElement(StyledContentSvgCard, { color: backgroundColor, isMisMidSizedContent: isMidSizedContent },
                    React.createElement(StyledFlex, null,
                        React.createElement(StyledDiv, null,
                            React.createElement(Icon, { icon: templateIcon }),
                            React.createElement(TemplateTitle, { templateText: templateText }),
                            React.createElement(TemplateFindOutMore, null)))))),
        React.createElement(Message, { message: message })));
};
export default TemplateTile;
